import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { RCUtils } from '../../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface AutoConfigState {
    SelectedReefers: any[];
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    RefDeviceConfig: USP_GetDeviceConfigurations_Result[];
    isLoading: boolean;
    CustomerFriendlyName: string;
    Template1: string;
    Template2: string;
    Template3: string;
    Template4: string;
    Template5: string;
    Template6: string;
    Template7: string;
    Template8: string;
    Template9: string;
    Template10: string;
    Email: string;
    ConfigValue: string;
    Filters: server.ForwardCommandParameters;
    VCCheckBoxInfo: VCCheckBoxData;   
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    AssetFilters: server.AssetParams,
}

export class AutoConfiguration extends React.Component<any, AutoConfigState> {
    constructor(props: any) {
        super(props);
        var filterSet = this.setDefaultFilters();
        var AssetFilterSet = this.setAssetFilters();
        this.state = {
            RefDeviceConfig: [], SelectedReefers: [], isLoading: false, ConfigValue: '', RowData: [], Email: '', CustomerFriendlyName: '', Template1: '', Template2: '', Template3: '', Template4: '',
            Template5: '', Template6: '', Template7: '', Template8: '', Template9: '', Template10: '', Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [],
            AssetFilters: AssetFilterSet
        }
    }

    getDeviceConfigurationsByCustomerId()
    { 
        $('#globalLoader').show();
        var forwardCommandParams = JSON.stringify(this.state.AssetFilters);
        //var url = Config.ApiBaseUrl + '/api/reeferstatus/GetDeviceConfigurationsByCustomer?customerId=' + customerId;

        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetDeviceConfigurationsByCustomer';

        var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<USP_GetDeviceConfigurations_Result[]>)
            .then(data => {

                this.setState({ RefDeviceConfig: data, isLoading: true });
                $('#globalLoader').hide();
               
            });
    }

    componentDidMount() {
        this.clearDeviceConfigData();
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderChangeZigbeeGrid(this.props.reeferData);
            this.getDeviceConfigurationsByCustomerId();                
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        $('#globalLoader').hide();
    }

    componentWillReceiveProps(nextprops: any) {
        this.clearDeviceConfigData();
        var reeferData = nextprops.reeferData;  
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderChangeZigbeeGrid(reeferData);
            this.getDeviceConfigurationsByCustomerId();
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    clearDeviceConfigData() {
        this.setState({
            Template1: '', Template2: '', Template3: '', Template4: '', Template5: '',
            Template6: '', Template7: '', Template8: '', Template9: '', Template10: '',
            ConfigValue: '', Email: ''
        });
    }

    DeviceConfigurationChange(event: React.FormEvent<HTMLSelectElement>) {
        this.setState({
            Template1: '', Template2: '', Template3: '', Template4: '', Template5: '',
            Template6: '', Template7: '', Template8: '', Template9: '', Template10: ''
        }); 
        var deviceConfig: string = event.currentTarget.value; 
        if (deviceConfig != '--Select--') {
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetDeviceConfigTemplates?configId=' + deviceConfig;
            var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<USP_GetDeviceConfigTemplates_Result[]>)
                .then(data => {
                    if (data.length > 0) {
                        this.setState({
                            ConfigValue: deviceConfig, Template1: data[0].Template1, isLoading: true, Template3: data[0].Template3, Template4: data[0].Template4,
                            Template5: data[0].Template5, Template6: data[0].Template6, Template7: data[0].Template7, Template8: data[0].Template8, Template9: data[0].Template9,
                            Template10: data[0].Template10, Template2: data[0].Template2
                        });
                    }
                    $('#globalLoader').hide();
                });
        }
        else {
            this.setState({
                ConfigValue: deviceConfig
            });
        } 
    }

    renderChangeZigbeeGrid(reeferData: any) {

        this.state.Filters.CommandName = "ZigbeeSettings";
        this.state.Filters.SelectedReefers = reeferData;
        //this.setState({ RowData: reeferData, SelectedSettings: "Enable" });
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }

    submitAutoConfiguration() { 
        //if (this.state.RefDeviceConfig != null) {
            var filters = new AutoConfigParams();
            filters.DeviceConfigId = this.state.ConfigValue;

            filters.EmailIds = this.state.Email;

            if (this.state.ConfigValue == '') {
                PopupWindow.showErrorMessage("Alert", "Please Enter Config.");
            } else if (this.state.Email == '') {
                PopupWindow.showErrorMessage("Alert", "Please Enter Email(s).");
            } else {

                var command = "AutoConfig";
                var filterParams = JSON.stringify(filters);
                var refreshGrid = this.props.refreshGrid;
                ReeferCommandsGrid.submitTemperatureCommands(command, filterParams, refreshGrid);
                this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
            } 
        //} else { PopupWindow.showErrorMessage("Error", "Please select Configurations."); }
    }

    EmailChange(event: React.FormEvent<HTMLTextAreaElement>) {               
        var Value: string = event.currentTarget.value.trim();
        this.setState({ Email: Value });
    } 

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "ZigbeeSettings", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }
    setAssetFilters() {
        var filters: server.AssetParams = {
            DeviceType: this.props.reeferData[0].DeviceType, customerId: this.props.reeferData[0].CustomerID
        };
        return filters;
    }
    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    public render() {
        return <div>
            <div className="modal-controls-container">
                <div className='row'>
                    <div className='col-xl-3 col-md-3 col-sm-12 text-lg-end text-md-end'>
                        <label className='col-form-label'>Configurations :</label>
                    </div>
                    <div className='col-xl-9 col-md-9 col-sm-12'>
                        <select className='form-select' id='configID' onChange={e => this.DeviceConfigurationChange(e)} value={this.state.ConfigValue}>
                            <option>--Select--</option>
                            {
                                this.state.RefDeviceConfig.map((item, index) =>
                                    <option key={index} value={item.DeviceConfigurationID}>{item.CustomerFriendlyName}</option>
                                )}
                        </select>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-xl-3 col-md-3 col-sm-12 text-lg-end text-md-end'>
                        <label className='col-form-label'>Email Address : </label>
                        </div>
                    <div className='col-xl-9 col-md-9 col-sm-12'>
                            <div className='input-group'>
                            <textarea name='txtUserEmailAddress' className='form-control texarea-inner' onChange={e => this.EmailChange(e)} value={this.state.Email}> </textarea>
                            </div>
                    </div>
                </div>                       
                <div className='row mt-2'>
                    <div className='col-xl-3 col-md-3 col-sm-12 text-lg-end text-md-end'>
                        <span className='col-form-label'>Templates :</span>
                    </div>
                    <div className='col-xl-9 col-md-9 col-sm-12'>
                        <span className='label-bold-left ms-2'>{this.state.Template1}</span>                       
                        <span className='label-bold-left ms-2'>{this.state.Template2}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template3}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template4}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template5}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template6}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template7}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template8}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template9}</span>
                        <span className='label-bold-left ms-2'>{this.state.Template9}</span>
                    </div>                   
                </div>
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} autoConfig={this.props.autoConfig} selectedReefers={this.state.RowData} commandName={"ZigbeeSettings"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitAutoConfiguration.bind(this)}>Save</button>
               
            </div>
         </div>       
    }
}

class USP_GetDeviceConfigurations_Result {
    FriendlyName: string;
    DeviceConfigurationID: number;
    Description: string;
    CustomerFriendlyName: string;
}

class USP_GetDeviceConfigTemplates_Result {
    Template1: string;
    Template2: string;
    Template3: string;
    Template4: string;
    Template5: string;
    Template6: string;
    Template7: string;
    Template8: string;
    Template9: string;
    Template10: string;
}

class AutoConfigParams
{
    DeviceConfigId: string;
    EmailIds:string
}